module.exports = __webpack_public_path__ + "static/img/MarkBickley.8beb4f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MarkBickley.jpg
// module id = j8hx
// module chunks = 0